export default "__VITE_ASSET__DvDoJiLv__"